import script from "./CMatchingSlot.vue?vue&type=script&setup=true&lang=ts"
export * from "./CMatchingSlot.vue?vue&type=script&setup=true&lang=ts"

import "./CMatchingSlot.vue?vue&type=style&index=0&id=00e9a10b&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00e9a10b"]])

export default __exports__